import AsyncStorage from "@react-native-async-storage/async-storage"
import { clientConfigPath } from "../../config/Constant";
import { fetchAllVenuesFailure, fetchAllVenuesRequest, fetchAllVenuesSuccess, fetchMyReservationFailure, fetchMyReservationRequest, fetchMyReservationSuccess } from "../Reducers/tableReservationReducer";


export const get7roomsRestaurantReservationData = () => async (dispatch) => {

    let sessionToken = await AsyncStorage.getItem('sessionToken');
    dispatch(fetchAllVenuesRequest());


    let payload = {

        "header": {
            "sessionToken": sessionToken
        },
        "payload": {
        }
    }

    try {
        let response = await clientConfigPath.post(`/restaurantTableBooking/getAllVenues`, payload);

        console.log('RESPONSE FROM ALL VENUE', response);

        if (response?.data?.payload?.data?.results) {
            // Dispatch success action with the fetched data
            dispatch(fetchAllVenuesSuccess(response.data.payload.data.results));
        } else {
            throw new Error('No data found');
        }
    } catch (error) {
        dispatch(fetchAllVenuesFailure(error.message));
    }

}


export const searchVenueAvailability = async (payload) => {

    let sessionToken = await AsyncStorage.getItem('sessionToken');

    let requestPayload = {
        "header": {
            "sessionToken": sessionToken
        },
        "payload": payload
    }

    try {
        let data = await clientConfigPath.post(`/restaurantTableBooking/getVenueAvailability`,requestPayload)
        console.log('DATA FOR VENUE AVAILABILITY -00000', data);
        return data
    } catch (error) {
        return error
    }
}


export const searchDailyProgrammeData = async (payload) => {

    let sessionToken = await AsyncStorage.getItem('sessionToken');
    let reservationNumber = await AsyncStorage.getItem('reservationNumber');
    let guestToken = await AsyncStorage.getItem('guestToken');

    let requestPayload = {
        "header": {
            "sessionToken": sessionToken,
            "reservationNumber": reservationNumber,
            "guestToken": guestToken,
        },
        "payload": payload
    }

    try {
        let data = await clientConfigPath.post(`/restaurantTableBooking/getAllPrograms`,requestPayload)
        console.log('DATA FOR DAILY ALL PROGRAMS 7777', data);
        return data
    } catch (error) {
        return error
    }
}


export const getMyReservationData =() => async (dispatch) => {

    let sessionToken = await AsyncStorage.getItem('sessionToken');
    let reservationNumber = await AsyncStorage.getItem('reservationNumber');
    let guestToken = await AsyncStorage.getItem('guestToken');
    let tableReservationClientId = await AsyncStorage.getItem('tableReservationClientId');


    console.log("tableReservationClientId", tableReservationClientId);

    dispatch(fetchMyReservationRequest());

    let requestPayload = {
        "header": {
            "sessionToken": sessionToken,
            "reservationNumber": reservationNumber,
            "guestToken": guestToken,
        },
        "payload": {
            "clientId": tableReservationClientId
        }
    }
    console.log('requestPayload for all reservation', requestPayload);

    if(!tableReservationClientId || tableReservationClientId == ""){

        return dispatch(fetchMyReservationSuccess([]));
    }

    try {
        let response = await clientConfigPath.post(`/restaurantTableBooking/getAllReservations`,requestPayload)
        // const venueId = response?.data?.payload?.data?.results[0]?.venue_id
        // console.log('VENUE ID', venueId);
        // if (venueId) {
        //     await AsyncStorage.setItem('venueId', venueId);
        // }
        dispatch(fetchMyReservationSuccess(response.data.payload));
        console.log("DATA ALL RESERVATION", response);

    } catch (error) {

        dispatch(fetchMyReservationFailure(error.message));
    }
}